import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";

const initialState = {
    deviceDataGridOptions: {
        loading: false,
        rows: [],
        totalRows: 0,
        rowsPerPageOptions: rowsPerPageJsonData,
        pageSize: 50,
        page: 1,
      },
    gatewaysDataGridOptions: {
        loading: false,
        rows: [],
        totalRows: 0,
        rowsPerPageOptions: rowsPerPageJsonData,
        pageSize: 50,
        page: 1,
      },
    roomTypeDataGridOptions: {
        loading: false,
        rows: [],
        totalRows: 0,
        rowsPerPageOptions: rowsPerPageJsonData,
        pageSize: 50,
        page: 1,
      },
    ratePlanDataGridOptions: {
        loading: false,
        rows: [],
        totalRows: 0,
        rowsPerPageOptions: rowsPerPageJsonData,
        pageSize: 50,
        page: 1,
      },
    deviceTab: 0,
    roomIdData: [],
    roomRateIdData: [],
    otaRoomRateIdData: [],
};
const managementSlice = createSlice({
  name: "management",
  initialState: initialState,
  reducers: {
    deviceTabSuccess: (state, action) => {
        state.deviceTab = action.payload;
    },
    roomIdDataSuccess: (state, action) => {
        state.roomIdData = action.payload;
    },
    roomRateIdDataSuccess: (state, action) => {
        state.roomRateIdData = action.payload;
    },
    otaRoomRateIdDataSuccess: (state, action) => {
        state.otaRoomRateIdData = action.payload;
    },
    deviceDataGridOptionsSucces: (state, action) => {
    state.deviceDataGridOptions = {...state.deviceDataGridOptions, [action.payload.key]: action.payload.value}
    },
    gatewaysDataGridOptionsSucces: (state, action) => {
    state.gatewaysDataGridOptions = {...state.gatewaysDataGridOptions, [action.payload.key]: action.payload.value}
    },
    roomTypeDataGridOptionsSucces: (state, action) => {
    state.roomTypeDataGridOptions = {...state.roomTypeDataGridOptions, [action.payload.key]: action.payload.value}
    },
    ratePlanDataGridOptionsSucces: (state, action) => {
    state.ratePlanDataGridOptions = {...state.ratePlanDataGridOptions, [action.payload.key]: action.payload.value}
    },
  },
});

export const {
    deviceTabSuccess,
    deviceDataGridOptionsSucces,
    gatewaysDataGridOptionsSucces,
    roomTypeDataGridOptionsSucces,
    ratePlanDataGridOptionsSucces,
    roomIdDataSuccess,
    roomRateIdDataSuccess,
    otaRoomRateIdDataSuccess
} = managementSlice.actions;
export default managementSlice.reducer;
